class ShapeHitTester {
    /**
     * Finds the first shape (recursing into package children) whose bounds
     * contain (x, y), excluding a given id.
     * @param {object[]} shapes
     * @param {number} x
     * @param {number} y
     * @param {string|null} excludeId
     * @returns {object|null}
     */
    static findAtPoint(shapes, x, y, excludeId) {
        for (let i = 0; i < shapes.length; i += 1) {
            const shape = shapes[i];
            if (shape.children) {
                const nestedHit = ShapeHitTester.findAtPoint(shape.children, x, y, excludeId);
                if (nestedHit) {
                    return nestedHit;
                }
            }
            if (shape.id !== excludeId && shape.containsPoint(x, y)) {
                return shape;
            }
        }
        return null;
    }
}

export default ShapeHitTester;
